import Icon from '../components/Icon.vue'

Icon.register({
  'clinic-medical': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 115l218.7 192.9c1.5 1.4 3.6 2 5.3 3.2v184.9c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-184.9c1.8-1.2 3.8-1.9 5.5-3.3zM384 376v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8zM570.7 236.3c2.9 2.6 5.3 8 5.3 11.9 0 3.4-1.8 8.2-4.1 10.7l-21.4 23.8c-2.6 2.9-8 5.3-11.9 5.3-3.4 0-8.2-1.8-10.7-4.1l-229.3-202.3c-2.5-2.2-7.2-4-10.6-4s-8.1 1.8-10.6 4l-229.3 202.3c-2.5 2.3-7.3 4.1-10.7 4.1-3.9 0-9.3-2.4-11.9-5.3l-21.4-23.8c-2.3-2.5-4.1-7.3-4.1-10.7 0-3.9 2.4-9.3 5.3-11.9l256-226c6.3-5.7 18.3-10.3 26.7-10.3 8.5 0 20.4 4.6 26.7 10.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/clinic-medical.js
// module id = null
// module chunks = 